import React from 'react';
import styles from './styles.module.css';

const Checkbox = ({
  className,
  id,
  label,
  labelSubText,
  labelSubTextTwo,
  ...rest
}: {
  className?: string;
  id: string;
  label?: string;
  labelSubText?: string;
  labelSubTextTwo?: string;
} & React.HTMLProps<HTMLInputElement>) => {
  return (
    <div className={'flex items-center cursor-pointer ' + className}>
      <input id={id} type="checkbox" className={styles.checkbox} {...rest} />
      {label && (
        <label htmlFor={id} className="ml-[14px] font-medium text-BrandGray800">
          {label}
          {labelSubText && <br />}
          {labelSubText && (
            <span className="text-xs text-BrandGray600">{labelSubText}</span>
          )}
          {labelSubTextTwo && <br />}
          {labelSubTextTwo && (
            <span className="text-xs text-BrandGray600">{labelSubTextTwo}</span>
          )}
        </label>
      )}
    </div>
  );
};

export default Checkbox;
